import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import CommonNav from './CommonNav'
import React, { useState } from "react";
import { Dropdown } from 'primereact/dropdown';
import { ListBox } from 'primereact/listbox';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

import { Steps } from 'primereact/steps';

import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { InputText } from 'primereact/inputtext';
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import { MultiSelect } from 'primereact/multiselect';
import { Tag } from 'primereact/tag';
import { TriStateCheckbox } from 'primereact/tristatecheckbox';






export default function Home() {
const [selectedCity, setSelectedCity] = useState(null);

const cities = [
        { name: 'School 1', code: 'NY' },
        { name: 'School 2', code: 'RM' },
        { name: 'School 3', code: 'LDN' },
        { name: 'School 4', code: 'IST' },
        { name: 'School 5', code: 'PRS' }
    ];

const people = [
        { name: 'Doug Paris', code: 'LDN' },
        { name: 'Jan Titus', code: 'IST' },
        { name: 'Mandy Smith', code: 'NY' },
        { name: 'Mike Madison', code: 'RM' },
        { name: 'Wendy Lopez', code: 'PRS' }
    ];

const people2 = [
        {id:1 ,name: 'Doug Paris', payrate: '$20' },
        {id:2 ,name: 'Jan Titus', payrate: '$20' },
        {id:3 ,name: 'Mandy Smith', payrate: '$25' },
        {id:4 ,name: 'Mike Madison', payrate: '$30' },
        {id:5 ,name: 'Wendy Lopez', payrate: '$40' },
        {id:6 ,name: 'Sadie Whitmore', payrate: '$20' },
        {id:7 ,name: 'Darren Zapp', payrate: '$20' },
        {id:8 ,name: 'Olivia Draper', payrate: '$25' },
        {id:9 ,name: 'Mindy Waylen', payrate: '$30' },
        {id:10, name: 'Dominic Hudson', payrate: '$40' },
        {id:11, name: 'Bonnie Blacksmith', payrate: '$20' },
        {id:12, name: 'Helen Liu', payrate: '$20' },
        {id:13, name: 'Scott Lessinger', payrate: '$25' },
        {id:14, name: 'Peter Baudine', payrate: '$30' },
        {id:15, name: 'Jessica Dresden', payrate: '$40' }
    ];

    const [filters, setFilters] = useState({
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
        name: { value: null, matchMode: FilterMatchMode.CONTAINS },
        payrate: { value: null, matchMode: FilterMatchMode.EQUALS }
    });

    const columns = [
        {field: 'name', header: 'Name'},
        {field: 'payrate', header: 'Pay Rate'}
    ];


    const stepsitems = [
        {
            label: 'Select School'
        },
        {
            label: 'Select Date Range'
        },
        {
            label: 'Review Available Subs'
        }
    ];





    return (
    <>
        <CommonNav></CommonNav>

            <Row>
                <Col>
                </Col>
                <Col xs={5}>

        <div className="card flex justify-content-center">
            <Dropdown value={selectedCity} onChange={(e) => setSelectedCity(e.value)} options={cities} optionLabel="name"
                placeholder="Select a School" className="w-full md:w-14rem" />
        </div>

<br />
<br />
<div className="card flex justify-content-center">
            <ListBox multiple options={people} optionLabel="name" className="w-full md:w-14rem" />
        </div>


<br />
<br />
<br />
<div className="card">
            <Steps model={stepsitems} activeIndex={1} />
        </div>

<br />
<br />
<br />
<div className="card">
            <DataTable value={people2} dataKey="id" tableStyle={{ minWidth: '50rem' }} paginator rows={10} filters={filters} filterDisplay="row"
            globalFilterFields={['name', 'payrate']} >
                {columns.map((col, i) => (
                    <Column key={col.field} field={col.field} header={col.header} />
                ))}
            </DataTable>
        </div>

                </Col>
                <Col>
                </Col>

            </Row>
        </ >




    );
}